import React from "react";
import PropTypes from "prop-types";

import { Icon, Label } from "semantic-ui-react";
import FormatCurrency from "shared/components/currency/FormatCurrency";

export const PriceLabel = props => {
  const { amount, isOnRequest } = props;

  if (isOnRequest) {
    return <Label className="on-request-tag">Preis auf Anfrage</Label>;
  }
  return (
    <Label className="price-tag">
      {amount >= 0 && <Icon name="plus" />}
      <FormatCurrency amount={amount} />
    </Label>
  );
};

PriceLabel.propTypes = {
  amount: PropTypes.number.isRequired,
  isOnRequest: PropTypes.bool
};
